import React from 'react';
import { withRouter } from 'react-router';

import LeadView from 'components/layout/lead/LeadView';

class LeadDetails extends React.Component {
  render() {
    const { match } = this.props;

    return <LeadView leadId={match.params.leadId} />;
  }
}

export default withRouter(LeadDetails);
